module.exports = __webpack_public_path__ + "img/29.9c416eca.jpg";